import * as React from 'react';
import { Res } from 'core/api';
import * as UI from 'core/ui';
import * as Images from 'pos/Images';
import { PaymentDirection, Transaction, TransactionTable, TransactionType, assertAreExternalTransactions } from './ExternalPaymentsService.Common';
import { ActionButtonDefinition } from 'core/ui';
import { Modal } from 'core/ui-next/modal';
import { PosStatelessScreenClassComponent, ScreenSize } from 'pos/ui';

export class WarnBeforeUndoingScreen extends PosStatelessScreenClassComponent<{
	type: TransactionType,
	direction: PaymentDirection,
	externalTransactions: Transaction[]
} & Modal.Actions<void>> {

	onComponentDidMount(): void {
	}

	onComponentWillUnmount(): void {
	}

	protected getScreenId(): string {
		return 'WARN_BEFORE_UNDOING_PAYMENT';
	}

	protected getTitle(): string {
		return Res.Common.WARNING();
	}

	protected getImage() {
		return Images.Warning;
	}

	protected getActionButtonsDefs(): Nullable<ActionButtonDefinition>[] {
		return [null, null, null, null, null, null];
	}

	protected useKeypad(): boolean {
		return false;
	}

	protected useKeyboard(): boolean {
		return false;
	}

	protected getSize(): ScreenSize {
		return 'small';
	}

	private getTexts(): { problemDescription: string, buttonText: string, nextAction: string } {
		const { direction, type } = this.props;

		if (type === 'NoDocument' && direction === 'PAY') {
			return {
				problemDescription: Res.Web.EXTERNAL_PAYMENT_UNDO_ALL_NO_DOCUMENT_PAY_PROBLEM_DESCRIPTION(),
				buttonText: Res.Web.EXTERNAL_PAYMENT_UNDO_ALL_NO_DOCUMENT_PAY_NEXT_ACTION_BTN(),
				nextAction: Res.Web.EXTERNAL_PAYMENT_UNDO_ALL_NO_DOCUMENT_PAY_NEXT_ACTION()
			};
		}
		if (type === 'NoDocument' && direction === 'REFUND') {
			return {
				problemDescription: Res.Web.EXTERNAL_PAYMENT_UNDO_ALL_NO_DOCUMENT_REFUND_PROBLEM_DESCRIPTION(),
				buttonText: Res.Web.EXTERNAL_PAYMENT_UNDO_ALL_NO_DOCUMENT_REFUND_NEXT_ACTION_BTN(),
				nextAction: Res.Web.EXTERNAL_PAYMENT_UNDO_ALL_NO_DOCUMENT_REFUND_NEXT_ACTION()
			};
		}

		if (direction === 'PAY') {
			return {
				problemDescription: Res.Web.EXTERNAL_PAYMENT_UNDO_ALL_PAY_PROBLEM_DESCRIPTION(),
				buttonText: Res.Web.EXTERNAL_PAYMENT_UNDO_ALL_PAY_NEXT_ACTION_BTN(),
				nextAction: Res.Web.EXTERNAL_PAYMENT_UNDO_ALL_PAY_NEXT_ACTION()
			};
		}

		if (direction === 'REFUND') {
			return {
				problemDescription: Res.Web.EXTERNAL_PAYMENT_UNDO_ALL_REFUND_PROBLEM_DESCRIPTION(),
				buttonText: Res.Web.EXTERNAL_PAYMENT_UNDO_ALL_REFUND_NEXT_ACTION_BTN(),
				nextAction: Res.Web.EXTERNAL_PAYMENT_UNDO_ALL_REFUND_NEXT_ACTION()
			};
		}

		throw new Error('No se debería poder alcanzar este punto');
	}

	protected getContent(): React.ReactNode {

		const { externalTransactions } = this.props;

		const { problemDescription, nextAction, buttonText } = this.getTexts();

		return <div className='p-m'>
			<p className='alert alert-danger m-b-md text-16' style={{ display: 'flex', alignItems: 'baseline' }}>
				<span className='fa fa-exclamation-circle m-r-sm'></span>{problemDescription}
			</p>

			<TransactionTable externalTransactions={externalTransactions} />

			<p className='m-t-md font-bold text-16 text-center'>
				{nextAction}
			</p>

			<UI.Button buttonStyle='primary' className='btn-block btn-lg m-t-md' style={{
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center'
			}} onClick={() => this.close()}>
				<Images.Warning className='m-r-sm' />
				<span>{buttonText}</span>
			</UI.Button>
		</div>;
	}

	static async warn(type: TransactionType, direction: PaymentDirection, externalTransactions: Transaction[]): Promise<void> {
		assertAreExternalTransactions(...externalTransactions);
		await Modal.show(WarnBeforeUndoingScreen, { type, direction, externalTransactions });
	}
}
